import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import cx from 'classnames';
import Icon from 'components/Icon';
import { PVI_NO_STYLES_CLASSNAME } from 'utils/helpers/inclusion';
import styles from './styles.module.scss';

const PlacemarkLayout = (ymaps) =>
	ymaps.templateLayoutFactory.createClass(
		renderToStaticMarkup(
			<div className={styles.Placemark}>
				<Icon
					icon="map-pin"
					className={cx(styles.Placemark__Icon, PVI_NO_STYLES_CLASSNAME)}
					useClassName={PVI_NO_STYLES_CLASSNAME}
				/>
			</div>
		)
	);

export default PlacemarkLayout;
